/// <reference types="vite/client" />
import { walletOriginHeaders } from "./stc-wallet/origin";
const packagedOrigin = import.meta.env?.VITE_STC_WALLET_API as string | undefined;
export function apiResourceUrl(path: string): string {
  return packagedOrigin && path.startsWith("/api/") ? `${packagedOrigin}${path}` : path;
}
// Compiled wallet packages use an allowlisted gateway. Public web routes retain
// their normal same-origin behavior. This does not patch global fetch.
export function apiFetch(input: RequestInfo | URL, init?: RequestInit): Promise<Response> {
  if (packagedOrigin && typeof input === "string" && input.startsWith("/api/")) {
    const headers = new Headers(init?.headers);
    for (const [name, value] of Object.entries(walletOriginHeaders())) headers.set(name, value);
    return globalThis.fetch(`${packagedOrigin}/api/wallet/service/${input.slice(5)}`, { ...init, headers, credentials: "omit" });
  }
  return globalThis.fetch(input, init);
}
